/* MONT DEGRÉS v1 — cœur spécifique des fiches (sections md-g-*, 23/10/2026 ; mise en forme maquette A le 24/10). Vanilla, sans dépendance.
   Témoin du bouton et zones qui s'allument (une fois, à l'arrivée à l'écran), niveaux de chauffe, couches qui se posent, conseiller « tour de main »,
   extraits d'avis, taille dans la barre collante. Sans script, tout reste lisible : photos allumées, niveau Moyen affiché, tableau des tailles complet. */
(()=>{
'use strict';
if(window.__mdCoeur)return;window.__mdCoeur=1;
const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
const store={get(k){try{return JSON.parse(localStorage.getItem(k)||'null');}catch(e){return null;}},set(k,v){try{localStorage.setItem(k,JSON.stringify(v));}catch(e){}}};
const once=(els,cb,th)=>{if(reduce||!('IntersectionObserver' in window)){els.forEach(e=>cb(e,true));return;}
  const io=new IntersectionObserver(en=>en.forEach(x=>{if(x.isIntersecting){io.unobserve(x.target);cb(x.target,false);}}),{threshold:th||.35});els.forEach(e=>io.observe(e));};
const armer=(sel,th)=>{const els=$$(sel);if(!reduce)els.forEach(f=>f.classList.add('is-armed'));once(els,f=>{requestAnimationFrame(()=>requestAnimationFrame(()=>f.classList.add('is-on')));},th);};

function start(){
  /* Une animation par section, jouée une fois : témoin du bouton, zones chauffantes, couches */
  armer('[data-md-g-bt]',.4);
  armer('[data-md-g-th]',.35);
  armer('[data-md-g-anim]',.3);

  /* Niveaux : intensité de la lueur, température, autonomie */
  $$('[data-md-g-lv]').forEach(g=>{
    const btns=$$('[role=radio]',g),sec=g.closest('section'),fig=$('[data-md-g-th]',sec),out=$('[data-md-g-out]',sec);
    const set=(b,user)=>{btns.forEach(x=>{x.setAttribute('aria-checked',x===b?'true':'false');x.tabIndex=x===b?0:-1;});
      if(fig){if(user)fig.classList.add('is-pret');fig.style.setProperty('--ir',b.dataset.ir||'1');}
      if(out){const t=$('[data-md-g-out-t]',out),h=$('[data-md-g-out-h]',out);if(t&&b.dataset.t)t.textContent=b.dataset.t;if(h&&b.dataset.h){h.innerHTML=b.dataset.h+'&nbsp;h';out.style.setProperty('--h',b.dataset.h);}}};
    btns.forEach((b,i)=>{b.addEventListener('click',()=>set(b,true));b.addEventListener('keydown',e=>{const d=e.key==='ArrowRight'||e.key==='ArrowDown'?1:e.key==='ArrowLeft'||e.key==='ArrowUp'?-1:0;if(!d)return;e.preventDefault();const n=btns[(i+d+btns.length)%btns.length];set(n,true);n.focus();});});
    const cur=btns.find(b=>b.getAttribute('aria-checked')==='true')||btns[0];if(cur)set(cur,false);
  });

  /* 25/10/2026 : [data-md-fit] = formule · explication sur une ligne si elle tient, sinon l'explication passe dessous (is-pile) */
  const fits=$$('[data-md-fit]');
  const fit=()=>fits.forEach(el=>{el.classList.remove('is-pile');const lh=parseFloat(getComputedStyle(el).lineHeight)||20;if(el.getBoundingClientRect().height>lh*1.5)el.classList.add('is-pile');});
  if(fits.length){fit();addEventListener('resize',fit);if(document.fonts&&document.fonts.ready)document.fonts.ready.then(fit);
    /* le carrousel d'avis est masqué jusqu'au chargement des avis : nouvelle mesure quand un bloc change de taille */
    if('ResizeObserver' in window){let raf=0;const ro=new ResizeObserver(()=>{cancelAnimationFrame(raf);raf=requestAnimationFrame(fit);});fits.forEach(el=>ro.observe(el.parentElement||el));}}

  /* Extraits d'avis du cœur (md-g-avis) : mêmes règles que le carrousel (Avis complets, jamais « Kilian P. »), texte tel quel */
  const avs=$$('[data-md-g-av]');
  const MDw=window.MD||{};
  if(avs.length&&MDw.avis){
    (MDw.avisGet?MDw.avisGet():fetch(MDw.avis).then(r=>r.json())).then(d=>{ /* 04/11/2026 : lecture partagée */
      const esc=t=>String(t||'').replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
      avs.forEach(el=>{
        const p=d&&d.produits&&d.produits[el.dataset.h];if(!p)return;
        const ok=(p.avis||[]).filter(a=>(MDw.complets||!a.demo)&&!/^kilian p\.?$/i.test(String(a.n||'').trim()));
        const ref=el.dataset.ref||'';let a;
        if(ref.startsWith('mot:')){const re=new RegExp('\\b'+ref.slice(4)+'s?\\b','i');a=ok.find(x=>x.note>=4&&re.test(x.x||''));}
        else a=ok.find(x=>x.id===ref);
        if(!a)return;
        const n=+a.note||5;
        el.innerHTML=`<blockquote>${a.t?`<b>${esc(a.t)}</b> `:''}« ${esc(a.x)} »</blockquote><figcaption><i class="md-stars" style="--n:${n}" aria-hidden="true"></i><span class="md-visually-hidden">Note ${n} sur 5, </span>${esc(a.n)}</figcaption>`;
        el.hidden=false;
      });
    }).catch(()=>{});
  }

  /* Barre collante : taille synchronisée avec la boîte d'achat */
  const sizeSet=$('form[data-md-product-form] [data-md-opt][data-required="true"]');
  const stkT=$('[data-md-g-stk-t]');
  if(stkT&&sizeSet){
    stkT.addEventListener('change',()=>{const inp=$$('input',sizeSet).find(x=>x.value===stkT.value);if(inp&&!inp.checked){inp.checked=true;inp.dispatchEvent(new Event('change',{bubbles:true}));}});
    sizeSet.addEventListener('change',()=>{const c=$('input:checked',sizeSet);if(c)stkT.value=c.value;});
    const stk=stkT.closest('[data-md-sticky]');
    if(stk)new MutationObserver(()=>{stkT.tabIndex=stk.classList.contains('is-on')?0:-1;}).observe(stk,{attributes:true,attributeFilter:['class']});
  }

  /* Conseiller « tour de main » : toutes les instances (section et dialogues) restent synchronisées */
  const forms=$$('[data-md-g-tm]');
  if(!forms.length)return;
  const KEY='md-tour-main';
  function advise(f,save){
    const v=parseFloat(String($('[name=tour]',f).value).replace(',','.'));
    const rows=$$('tbody tr[data-tour]',f);const res=$('[data-md-g-tm-res]',f),say=$('[data-md-g-tm-say]',f),pick=$('[data-md-g-tm-pick]',f);
    rows.forEach(r=>r.classList.remove('is-hit'));
    if(!v||v<10||!rows.length){res.hidden=true;return null;}
    const i=rows.findIndex(r=>parseFloat(r.dataset.tour)>=v-0.05);
    const last=rows.length-1;
    if(i<0){res.hidden=false;say.innerHTML=`Au-delà de ${rows[last].dataset.tour.replace('.',',')} cm : <a class="md-link" href="/pages/contact">écrivez-nous</a>, réponse sous 24 h.`;pick.hidden=true;if(save)store.set(KEY,{v});return null;}
    const entre=parseFloat(rows[i].dataset.tour)>v+0.05&&i>0;
    const sz=rows[i].dataset.sz;rows[i].classList.add('is-hit');
    say.innerHTML=`Taille conseillée : <b>${sz}</b>${entre?' <small>(entre deux tailles : au-dessus)</small>':''}`;
    $$('[data-md-g-tm-sz]',f).forEach(x=>x.textContent=sz);
    pick.hidden=!sizeSet||!$$('input',sizeSet).some(x=>x.value===sz);
    res.hidden=false;
    if(save)store.set(KEY,{v});
    return sz;
  }
  forms.forEach(f=>{
    const go=()=>{advise(f,true);forms.forEach(o=>{if(o!==f){$('[name=tour]',o).value=$('[name=tour]',f).value;advise(o,false);}});};
    f.addEventListener('input',go);f.addEventListener('change',go);
    const pick=$('[data-md-g-tm-pick]',f);
    pick.addEventListener('click',()=>{
      const sz=advise(f,true);if(!sz||!sizeSet)return;
      const inp=$$('input',sizeSet).find(x=>x.value===sz);if(!inp)return;
      inp.checked=true;inp.dispatchEvent(new Event('change',{bubbles:true}));
      const dlg=f.closest('dialog');if(dlg&&dlg.open)dlg.close();
      const r=sizeSet.getBoundingClientRect();if(r.top<0||r.bottom>innerHeight)sizeSet.scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'});
      pick.textContent='Taille '+sz+' choisie ✓';setTimeout(()=>{pick.innerHTML='Choisir <span data-md-g-tm-sz>'+sz+'</span>';},1600);
    });
  });
  const mem=store.get(KEY);
  if(mem&&mem.v)forms.forEach(f=>{$('[name=tour]',f).value=mem.v;advise(f,false);});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
